/**
 * @file utils/cookies/constants.js
 * @copyright 2017 CBC/Radio-Canada. All rights reserved.
 */

export const GUEST_COOKIE = "cbc_visitor";
export const AUTHED_COOKIE = "cbc_plus";
export const LR_COOKIE = "lr-user--token";
export const LOCAL_COOKIE = "cbclocal";

export const RADIO_REGEX = "radio%3D([a-zA-Z-_]+)";
export const COOKIE_DOMAIN = ".cbc.ca";
